import { Component, OnInit } from '@angular/core';
import { MipsService } from 'src/app/services/mips.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-scale',
  templateUrl: './create-scale.component.html',
  styles: [
  ]
})
export class CreateScaleComponent implements OnInit {

  public title = "";
  public group = "";
  public scales = [];
  public isEditing = false;
  public editingIndex = 0;
  constructor(
    private mipsService:MipsService
  ) { }

  ngOnInit(): void {
    this.mipsService.getScales().subscribe(
      resp=>{
        this.scales = resp;
      },
      err=>console.log(err)
    )
  }

  createScale(){
    console.log(this.group)
    this.mipsService.createScale({scale:this.title, group:this.group}).subscribe(
      resp=>{
        Swal.fire("Escala creada");
        this.scales.push(resp);
        this.title = "";
        this.group = "";
      },
      err=>console.log(err)
    )
  }

  editScale(){
    let _id = this.scales[this.editingIndex]._id;
    this.mipsService.editScale({_id:_id, title:this.title, group: this.group}).subscribe(
      resp=>{
        Swal.fire("Escala actualizada");
        this.scales[this.editingIndex].scale = this.title;
        this.scales[this.editingIndex].group = this.group;
        this.title = "";
        this.group = "";
      },
      err=>console.log(err)
    )
  }

  handleEdit(scale,i){
    this.isEditing = true;
    this.editingIndex = i;
    this.title = scale.scale;
    this.group = scale.group;
  }

  deleteScale(i, _id){
    Swal.fire({
      icon:'question',
      title:'¿Borrar escala?',
      showCancelButton:true
    }).then(
      resp=>{
        if(resp.isConfirmed){
          this.mipsService.deleteScale({_id:_id}).subscribe(
            resp=>{
              this.scales.splice(i,1);
              Swal.fire("Escala borrada");
            },
            err=>console.log(err)
          )
        }
      }
    )
  }

}
